// Shared links (2026-10-25). Every link a reader shares says where it went
// (utm_source = the channel, utm_medium = share, utm_campaign = what kind of
// page), so a friend's visit shows in GA4 as "x / share", not as Direct with
// the bots. Never utm_medium=email: that marks a newsletter click, which
// counts against the story allowance (services/access/reader-access), and a
// friend's first story is free.
//
// A signed-in reader's link also carries their referral code (?ref=), which
// src/proxy.js keeps in the same cookie pano.news/r/<code> sets and strips
// from the address, so the stories they share count as referrals.

export const REF_PARAM = 'ref'

export function shareLink(url, { source, kind = 'story', code = null }) {
  try {
    const u = new URL(url)
    u.searchParams.set('utm_source', source)
    u.searchParams.set('utm_medium', 'share')
    u.searchParams.set('utm_campaign', kind)
    if (code) u.searchParams.set(REF_PARAM, code)
    return u.toString()
  } catch {
    return url
  }
}

const enc = encodeURIComponent

// The desktop modal's networks, in order. Phones get the system share sheet
// instead (Messages, WhatsApp, every app the reader has), so WhatsApp isn't
// here. No @handle on X (Sam, 2026-10-25): the headline and the link, and
// the share card carries the name.
export const NETWORKS = [
  {
    id: 'x',
    label: 'X',
    href: (url, title) =>
      `https://x.com/intent/post?text=${enc(title)}&url=${enc(url)}`,
  },
  {
    id: 'facebook',
    label: 'Facebook',
    href: (url) => `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
  },
  {
    id: 'bluesky',
    label: 'Bluesky',
    href: (url, title) =>
      `https://bsky.app/intent/compose?text=${enc(`${title} ${url}`)}`,
  },
  {
    id: 'reddit',
    label: 'Reddit',
    href: (url, title) =>
      `https://www.reddit.com/submit?url=${enc(url)}&title=${enc(title)}`,
  },
  {
    id: 'mail',
    label: 'Email',
    href: (url, title) =>
      `mailto:?subject=${enc(title)}&body=${enc(`${title}\n\n${url}`)}`,
  },
]
